
import { computed, defineComponent, onBeforeUnmount, useStore } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '@/assets/util'
import { setupGtmCdpAction } from '@/assets/composition/setup-gtm'

export default defineComponent({
  props: {
    audioWork: { type: Object, required: false, default: null },
    toggleHeaderAudio: { type: Function, required: false, default: () => {} },
  },
  setup(props) {
    const store = useStore()
    const { t_ } = setupTranslationPrefixer('event-detail')
    const gtmCdpAction = setupGtmCdpAction()
    const composer = props.audioWork?.composers?.[0]?.title
    const work = props.audioWork?.title || ''
    const url = props.audioWork?.audio?.url || ''
    const playerStates = computed(() => store.getters['audio-player/playerStates'])
    const isPlaying = computed(() => playerStates.value[props.audioWork.id])

    function toggleAudio() {
      if (!isPlaying) {
        gtmCdpAction('CV07 - Header music fragment clicked')
      }

      store.dispatch('audio-player/toggleAudio', props.audioWork.id)
    }

    onBeforeUnmount(() => (isPlaying.value === true ? store.dispatch('audio-player/toggleAudio', props.audioWork.id) : null))

    return {
      t_,
      composer,
      work,
      url,
      toggleAudio,
      playerStates,
      isPlaying,
    }
  },
})
